// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor4 from '@/game/prefabs/World/Mentors/Mentor4';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level20 extends TilemapScene {
  constructor() {
    super('Level20');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // winter_biome_5
    const winter_biome_5 = this.add.tilemap('winter-biome-5');
    winter_biome_5.addTilesetImage(
      'winter forest wang tiles (snowy)',
      'winter forest wang tiles (snowy)',
    );
    winter_biome_5.addTilesetImage(
      'winter forest (snowy)',
      'winter forest (snowy)',
    );
    winter_biome_5.addTilesetImage('steampunk manor', 'steampunk manor');
    winter_biome_5.addTilesetImage('bonus shadows', 'bonus shadows');
    winter_biome_5.addTilesetImage(
      'winter trees (snowy) 80x112',
      'winter trees (snowy) 80x112',
    );
    winter_biome_5.addTilesetImage('collision', 'collision & alpha');
    winter_biome_5.addTilesetImage(
      'winter water sparkles B 16x16',
      'summer water sparkles B 16x16',
    );

    // terrain_1
    winter_biome_5.createLayer(
      'terrain',
      ['winter forest wang tiles (snowy)'],
      0,
      0,
    );

    // cliff_1
    winter_biome_5.createLayer('cliff', ['winter forest (snowy)'], 0, 0);

    // deco
    winter_biome_5.createLayer(
      'deco 1',
      ['winter forest (snowy)', 'winter water sparkles B 16x16'],
      0,
      0,
    );

    // manor_1
    winter_biome_5.createLayer(
      'manor',
      ['steampunk manor', 'bonus shadows'],
      0,
      0,
    );

    // tOP_manor_roof_1
    winter_biome_5.createLayer(
      'TOP manor roof',
      ['steampunk manor', 'bonus shadows'],
      0,
      0,
    );

    // tOP_manor_extra_1
    winter_biome_5.createLayer(
      'TOP manor extra',
      ['winter forest (snowy)', 'steampunk manor'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = winter_biome_5.createLayer(
      'COLLISION',
      ['collision'],
      0,
      8,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 24, 200);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 176, 272);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 352, 360);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 632, 304);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 384, 120);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 280, 512);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 704, 496);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 712, 536);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      512,
      384,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(this, 48, 144, 'winter (snowy) 32x', 2);
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      224,
      112,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      672,
      208,
      'winter (snowy) 32x',
      2,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      440,
      96,
      'winter (snowy) 48x',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      168,
      368,
      'winter (snowy) 48x',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      232,
      480,
      'winter (snowy) 48x',
      0,
    );
    this.add.existing(forestTree_5);

    // mentor
    const mentor = new Mentor4(this, 48, 144);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 592, 432);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 464, 352);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 416, 456);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 280, 216);
    this.add.existing(worldNode_9);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 19;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 19;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 19;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 19;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 19;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 19;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 19;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 19;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 19;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 19;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.winter_biome_5 = winter_biome_5;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor4;
  private winter_biome_5!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.winter_biome_5,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
